import { request } from '../client'

// Models
import type {
  ProfileDepositsParams,
  ProfileDepositsResponse,
  ProfileResponse,
  PublicProfileResponse,
  ReferralStatsResponse,
} from '@/services/models/response'

// Get current user's profile and stats
export async function getProfile() {
  return request<ProfileResponse>({
    method: 'GET',
    url: '/v1/profile/me',
  })
}

// Get current user's deposit history
export async function getProfileDeposits(params: ProfileDepositsParams = {}) {
  return request<ProfileDepositsResponse>({
    method: 'GET',
    url: '/v1/profile/me/deposits',
    params,
  })
}

// Get user balance and case tokens
export async function getBalance() {
  return request<{ balance: number; caseToken: number }>({
    method: 'GET',
    url: '/v1/profile/me/balance',
  })
}

// Get public profile and stats by user id
export async function getPublicProfile(userId: string) {
  return request<PublicProfileResponse>({
    method: 'GET',
    url: `/v1/profile/public/${userId}`,
    skipAuth: true,
  })
}

// Set or Update user's email - verification will be sent by backend
export async function setEmail(email: string) {
  return request<void>({
    method: 'POST',
    url: '/v1/profile/me/email',
    data: { email },
  })
}

// Get user' referral code stats
export async function getReferralStats() {
  return request<ReferralStatsResponse>({
    method: 'GET',
    url: '/v1/profile/me/referral-code',
  })
}

// Create a new referral code
export async function createReferralCode(referralCode: string) {
  return request<void>({
    method: 'POST',
    url: '/v1/profile/me/referral-code/create',
    data: { referralCode },
  })
}

// Use a referral code
export async function useReferralCode(referralCode: string) {
  return request<void>({
    method: 'POST',
    url: '/v1/profile/me/referral-code/use',
    data: { referralCode },
  })
}

// claim referral code earnings
export async function claimReferralEarnings() {
  return request<{ claimedAmount: number }>({
    method: 'POST',
    url: '/v1/profile/me/referral-code/claim-cut',
  })
}

// Claim deposit streak reward
export async function claimDepositStreak() {
  return request<any>({
    method: 'POST',
    url: '/v1/profile/me/deposit-streak/claim',
  })
}
